import React, { useEffect, useState } from "react";
import "./serviceBooking.css";
import queryString from "query-string";
import axios from "axios";
import { getJWT } from "../../helpers/Helper";
import { toast, ToastContainer } from "react-toastify";
import Footer from "../../components/footer/Footer";
import Navigation from "../../components/navigation/Navigation";
import { Spinner } from "react-bootstrap";
import Badge from "../../components/badge/Badge";
import { Rating } from "@mui/material";
import Button from "../../components/button/Button";

const RenderLoading = () => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <Spinner animation="border" variant="darke" />
  </div>
);

function ServiceBooking() {
  const { service_id } = queryString.parse(window.location.search);

  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [serviceData, setServiceData] = useState();
  const [rateValue, setRateValue] = useState(0);
  const [review, setReview] = useState();

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `https://the-outlet-vendor-api.herokuapp.com/bookings/${service_id}/customer`,
        { headers: { Authorization: `Bearer ${getJWT()}` } }
      )
      .then((res) => {
        setServiceData(res && res.data);
        setLoading(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      });
  }, []);

  const handleRating = () => {
    setLoadingButton(true);

    axios
      .post(
        `https://the-outlet-vendor-api.herokuapp.com/bookings/${service_id}/rate`,
        {
          rate: rateValue,
          comment: review,
        },
        { headers: { Authorization: `Bearer ${getJWT()}` } }
      )
      .then((res) => {
        toast("Vendor Successfully Rated & Reviewed!", {
          type: "success",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setRateValue(0);
        setReview("");
        setLoadingButton(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoadingButton(false);
      });
  };

  return (
    <div className="serviceBooking">
      <Navigation
        background="theme-color"
        logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
      />

      <div className="serviceBooking_content">
        {serviceData && loading ? (
          RenderLoading()
        ) : (
          <div className="serviceBooking_orderCard">
            {serviceData && (
              <React.Fragment>
                <div className="serviceBooking_section1">
                  <div className="serviceBooking_vendorImg">
                    <img
                      src={serviceData.vendorService.imageUrl}
                      alt={serviceData.vendorService.name}
                    />
                  </div>

                  <div className="serviceBooking_details">
                    <h3>{serviceData.vendorService.name}</h3>
                    <p>{serviceData.vendorService.service.name}</p>
                    <h6>Event: {serviceData.title}</h6>
                    <h6>Venue: {serviceData.location}</h6>
                    <div className="serviceBooking_status">
                      <h6>Status: </h6>
                      <Badge content={serviceData.status} />
                    </div>
                  </div>
                </div>

                <div className="serviceBooking_section2">
                  <div className="serviceBooking_description">
                    <h6>DESCRIPTION</h6>
                    <p>{serviceData.description}</p>
                  </div>

                  <div className="serviceBooking_price">
                    <h6>PRICING</h6>
                    <p>
                      {`${serviceData.units} ${serviceData.unit}${
                        serviceData.units > 1 ? "s" : ""
                      } Event: `}
                      <span>{`Kshs ${serviceData.totalAmount}`}</span>
                    </p>
                  </div>
                </div>

                <form className="serviceBooking_section3">
                  <label>Rate Vendor*</label>
                  <Rating
                    name="simple-controlled"
                    className="rating"
                    value={rateValue}
                    onChange={(event, newValue) => {
                      setRateValue(newValue);
                    }}
                  />

                  <label style={{ marginTop: "1rem" }}>Vendor Review*</label>
                  <textarea
                    type="text"
                    placeholder="Vendor Review"
                    value={review}
                    onChange={(e) => setReview(e.target.value)}
                  />

                  <Button
                    onClickHandler={handleRating}
                    content={
                      loadingButton ? RenderLoading() : `Submit Rating & Review`
                    }
                    contentColor="white"
                    borderRadius="all"
                    buttonColor="main-bg"
                  />
                </form>
              </React.Fragment>
            )}
          </div>
        )}
      </div>

      <Footer />

      <ToastContainer />
    </div>
  );
}

export default ServiceBooking;
